import React, { createContext, useContext, useEffect, useState } from "react";
import services from "../services/services";
const AppContext = createContext();

export const useAppContext = () => {
	return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
	const tenantGroup = sessionStorage.getItem("tenant_group");

	const [showCookiePreferenceModal, setShowCookiePreferenceModal] =
		useState(false);

	const [showCookieBanner, setShowCookieBanner] = useState(
		localStorage.getItem(`${tenantGroup}.cookiePreference`) ? false : true
	);
	const [cookiePreference, setCookiePreference] = useState({
		essential: false,
		performance: false,
		functional: false,
		targeting: false,
	});

	const [features, setFeatures] = useState();
	const [loadingFeatures, setLoadingFeatures] = useState(false);

	const fetchFeatures = () => {
		console.log("Fetching features");
		setLoadingFeatures(true);
		services
			.getFeatures()
			.then((response) => {
				console.log(response);
				setFeatures(response);
			})
			.finally(() => {
				setLoadingFeatures(false);
			});
	};

	const saveCookiePreference = (cookiePref) => {
		if (cookiePref) {
			const cookiePrefJSON = JSON.stringify(cookiePref);
			localStorage.setItem(`${tenantGroup}.cookiePreference`, cookiePrefJSON);
			if (showCookieBanner) {
				setShowCookieBanner(false);
			}
		}
	};

	useEffect(() => {
		// Get user cookie preferences
		const storedCookiePreference = localStorage.getItem(
			`${tenantGroup}.cookiePreference`
		);
		if (storedCookiePreference) {
			setCookiePreference(JSON.parse(storedCookiePreference));
		}

		// fetchFeatures();
	}, []);

	return (
		<AppContext.Provider
			value={{
				tenantGroup,
				features,
				setFeatures,
				loadingFeatures,
				setLoadingFeatures,
				showCookiePreferenceModal,
				showCookieBanner,
				setShowCookiePreferenceModal,
				cookiePreference,
				setCookiePreference,
				saveCookiePreference,
			}}
		>
			{children}
		</AppContext.Provider>
	);
};
